/**
 * Checks if the argument is defined
 * @param arg 
 * @returns 
 */
export function isDefined<T>(arg: T | undefined) : arg is T {
    return typeof arg !== 'undefined'
}